export interface LoadTransactionDto {
  loadTransactionTypeId: string;
  loadTransactionId: string;
  loadId: string;
}
